import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryCards from './components/CategoryCards';
import ArticlePreview from './components/ArticlePreview';
import FAQ from './components/FAQ';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sugargoosheet.icu';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: 'Sugargoo Spreadsheet - Ultimate Sugargoo Sheet Database & Buying Guide 2026',
      description: 'Discover the best Sugargoo Spreadsheet resources, product finds, buying guides, shipping tips, reviews, coupons and safety information. Updated for 2026.',
      isPartOf: {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        name: 'Sugargoo Spreadsheet',
        url: `${siteUrl}/`,
      },
      about: {
        '@type': 'Thing',
        name: 'Sugargoo Spreadsheet',
      },
      primaryImageOfPage: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
      },
    },
    {
      '@type': 'FAQPage',
      '@id': `${siteUrl}/#faq`,
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What is Sugargoo Spreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sugargoo Spreadsheet is a structured resource system that helps shoppers discover products, organize finds and compare different options before purchasing. Instead of searching thousands of products manually, users can explore categorized spreadsheets including sneakers, clothing, streetwear, accessories, electronics, and fashion items curated by experienced community members.',
          },
        },
        {
          '@type': 'Question',
          name: 'How does Sugargoo Spreadsheet work?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Community members discover products through various channels and organize them into spreadsheet databases categorized by product type. Each entry includes product name, direct purchase link, price range, available sizes and colors, quality ratings, and real buyer photos. This collaborative system makes product discovery significantly faster and more reliable than individual searching.',
          },
        },
        {
          '@type': 'Question',
          name: 'Is Sugargoo legit and safe to use?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sugargoo is a legitimate shopping agent service used by millions of international buyers. However, as with any online shopping platform, we recommend verifying seller information, protecting your payment details, understanding shipping policies, and avoiding suspicious links.',
          },
        },
        {
          '@type': 'Question',
          name: 'How much does Sugargoo shipping cost?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sugargoo shipping costs vary based on package weight, destination country, and shipping method selected. International shipping options range from economy lines for budget-conscious shoppers to express courier services for faster delivery.',
          },
        },
        {
          '@type': 'Question',
          name: 'Where is the Sugargoo warehouse located?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Sugargoo operates warehouses in China where purchased items are received, inspected, and stored before international shipping. The warehouse team performs quality checks, takes inspection photos, and consolidates multiple orders into single shipments.',
          },
        },
        {
          '@type': 'Question',
          name: 'How can I find the best Sugargoo Spreadsheet discounts?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'The Sugargoo platform periodically offers coupons, discount codes, and promotional events for both new and returning users. Check the official Sugargoo website for current promotions and follow the community forums for the latest saving strategies.',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryDropdown />
        <CategoryCards />
        <ArticlePreview />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}